<template>
  <v-snackbar v-model="snackBar" :color=snackColor :multi-line=snackMultiLine :timeout=snackTimeout >
    {{ snackText }}
    <v-btn dark flat @click="snackBar = false" > X </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackBar',
  computed: {
    snackBar: {
      get () { return this.$store.state.snackBar },
      set (value) { this.$store.state.snackBar = value }
    },
    snackColor: {
      get () { return this.$store.state.snackColor },
      set (value) { this.$store.state.snackColor = value }
    },
    snackMultiLine: {
      get () { return this.$store.state.snackMultiLine },
      set (value) { this.$store.state.snackMultiLine = value }
    },
    snackTimeout: {
      get () { return this.$store.state.snackTimeout },
      set (value) { this.$store.state.snackTimeout = value }
    },
    snackText: {
      get () { return this.$store.state.snackText },
      set (value) { this.$store.state.snackText = value }
    }
  }
}
</script>

<style scoped>

</style>
